import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

export default function RadioInput(props) {

  const { errors, label, radios, inputRef, hideLabel, hideError,squareIcon, ...radioGroupProps} = props;

  const formControlLabels = radios && radios.map((option, key) => {
    return squareIcon ? (<FormControlLabel value={option.value} key={key} label={option.label} control={<Radio icon={<CheckBoxOutlineBlankIcon />} color="primary" checkedIcon={<CheckBoxIcon/>} inputRef={inputRef} />} />):(<FormControlLabel value={option.value} key={key} label={option.label} control={<Radio color="primary" inputRef={inputRef} />} />)
  })

  return (
    <div>
      <FormControl component="fieldset" error={!!errors}>

        {(!hideLabel) &&
          <FormLabel component="legend">{label}</FormLabel>
        }

        <RadioGroup {...radioGroupProps}>
          {formControlLabels}
        </RadioGroup>

        {(!hideError) &&
          <FormHelperText>{errors && errors.message}</FormHelperText>
        }
      </FormControl>
    </div>
  )

}

RadioInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  radios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  inputRef: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  errors: PropTypes.object,
  hideLabel: PropTypes.bool,
  hideError: PropTypes.bool,
  squareIcon: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/RadioInput.js